import { theme } from '@frontend/theme';

export const ToolboxDivider = () => (
  <hr
    css={{
      border: 0,
      borderTop: `solid 1px ${theme.colors.neutral20}`,
      margin: theme.spacing(1, 0),
    }}
  />
);
